'use client';

import { ReactNode } from 'react';
import { useAuth } from '../../hooks/useAuth';

interface SignedInProps {
  children: ReactNode;
}

export function SignedIn({ children }: SignedInProps) {
  const { isAuthenticated } = useAuth();
  
  if (!isAuthenticated) {
    return null;
  }

  return <>{children}</>;
}